import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik, FormikHelpers, Field } from "formik";
import Error from "../../../../../atoms/Error";
import PasswordStrengthIndicator from "../../../../../organisms/passwordStrengthIndicator";
import * as yup from "yup";
import { getData, patchData, postData } from "../../../../../../services";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../../assets/styles/toast";
import { useCookies } from "react-cookie";
import InputLayout from "../../../../../atoms/InputLayout";
import ChangePasswordField from "../../../../../atoms/ChangePasswordField";

const ProfileSettings = ({ uid, expiry, token, type, usertype }) => {
  const navigate = useNavigate();

  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [cookies] = useCookies(["e_t"]);
  const [initialData, setInitialData] = useState();

  // Form
  const initialValues = {
    currPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = yup.object().shape({
    ...(initialData?.password_created === true
      ? {
          currPassword: yup.string().required("Current Password is required"),
        }
      : {}),
    newPassword: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'`~<>?,./\\|-])/,
        "Password must contain at least one uppercase letter (A-Z), one lowercase letter (a-z), one digit (0-9), and one special character (~`!@#$%^&*()+=-{}[]|:;”’?/<>,.)"
      )
      .required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword")], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const employeeInfo = async () => {
    try {
      const res = await getData({
        endpoint: "Employee/GetEmployeeById",
        params: {
          id: cookies?.euid,
        },
        token: cookies?.e_t,
      });

      if (res) {
        setInitialData(res?.data);
      }
    } catch (err) {
      // toast.error("Error Creating Employee", { style: errorStyles });
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const res = await patchData({
        endpoint: "Employee/changePasswordAsync",
        data: {},
        params: {
          employee_id: cookies?.euid,
          currPassword: values?.currPassword,
          newPassword: values?.newPassword,
          confirmPassword: values?.confirmPassword,
        },
        token: cookies?.e_t,
      });

      resetForm();
      if (res.status) {
        toast.success(
          initialData?.password_created === false 
            ? "Password Created Successfully" 
            : "Password Reset Successfully",
          {
            duration: 1000,
            style: confimationStyles,
          }
        );
        // Refresh the employee info to get the updated password_created status
        await employeeInfo();
      } 
    } catch (error) {
      // console.log('err',error)
      toast.error("Current password is incorrect.", {
        duration: 1000,
        style: errorStyles,
      });
    }
    setSubmitting(false);
  };

  useEffect(() => {
    employeeInfo();
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      initialStatus={{ password_created: initialData?.password_created }}
    >
      {({
        handleSubmit,
        touched,
        errors,
        values,
        isValid,
        dirty,
        handleBlur,
        isSubmitting,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <div className="d-flex flex-column gap-3">
            {initialData?.password_created === true ? (
              <div style={{ width: "30%" }}>
                <ChangePasswordField
                  label="Current Password"
                  id="currPassword"
                  name="currPassword"
                  value={values.currPassword}
                  onChange={(e) =>
                    setFieldValue("currPassword", e.target.value)
                  }
                  onBlur={handleBlur}
                  placeholder="Enter your Password"
                  className={`${
                    (touched.currPassword || isSubmitting) &&
                    errors.currPassword
                      ? "error-input"
                      : ""
                  }`}
                />
                {(touched.currPassword || isSubmitting) &&
                  errors.currPassword && <Error error={errors.currPassword} />}
              </div>
            ) : null}

            <div style={{ width: "30%" }}>
              <ChangePasswordField
                label="Password"
                id="newPassword"
                name="newPassword"
                value={values.newPassword}
                onChange={(e) => setFieldValue("newPassword", e.target.value)}
                onBlur={handleBlur}
                placeholder="Enter your Password"
                className={`${
                  (touched.newPassword || isSubmitting) && errors.newPassword
                    ? "error-input"
                    : ""
                }`}
              />
              {(touched.newPassword || isSubmitting) && errors.newPassword && (
                <Error error={errors.newPassword} />
              )}
            </div>

            <div style={{ width: "30%" }}>
              <ChangePasswordField
                label="Confirm Password"
                id="confirmPassword"
                name="confirmPassword"
                value={values.confirmPassword}
                onChange={(e) =>
                  setFieldValue("confirmPassword", e.target.value)
                }
                onBlur={handleBlur}
                placeholder="Enter your Password"
                className={`${
                  (touched.confirmPassword || isSubmitting) &&
                  errors.confirmPassword
                    ? "error-input"
                    : ""
                }`}
              />
              {(touched.confirmPassword || isSubmitting) &&
                errors.confirmPassword && (
                  <Error error={errors.confirmPassword} />
                )}
            </div>
          </div>

          <button
            className="btn btn-primary mt-4"
            disabled={!isValid || !dirty || isSubmitting}
            type="submit"
          >
            {initialData?.password_created === false ? "Create" : "Reset"}{" "}
            Password
            {isSubmitting && (
              <span
                className="spinner-border spinner-border-sm ms-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>
        </Form>
      )}
    </Formik>
  );
};

export default ProfileSettings;
